<template>
    <div class="field">
        <label :for="id" class="radio" :class="{ 'is-danger': error }">
            <input
                :id="id"
                type="radio"
                :name="name"
                :value="value"
                :checked="state"
                @change="onChange"
            />
            <span class="radio-indicator"></span>
            <span class="radio-label">
                <slot></slot>
            </span>
            <span v-if="!hideSpace">&nbsp;</span>
            <fa-icon
                v-if="tooltip"
                v-tooltip.top="tooltip"
                icon="info-circle"
                class="configurationProfile__tooltip-icon"
            />
        </label>
        <p v-if="error" class="help is-danger" v-text="error" />
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'input'],

    props: {
        name: { type: String, default: null },
        value: { type: [String, Number], default: '' },
        modelValue: { type: [String, Number], default: undefined },
        checked: { type: Boolean, default: false },
        error: { type: String, default: '' },
        model: {},
        tooltip: { type: String, default: '' },
        hideSpace: { type: Boolean, default: false },
    },

    data() {
        return {
            id: `radio-${this.$.uid}`,
        };
    },

    computed: {
        state() {
            if (this.modelValue === undefined) {
                return this.checked;
            } else {
                return this.modelValue === this.value;
            }
        },
    },

    watch: {
        checked(val) {
            if (val !== this.state) {
                this.toggle();
            }
        },
    },

    methods: {
        onChange() {
            this.toggle();
        },

        toggle() {
            this.$emit('input', this.state ? '' : this.value);
            this.$emit('update:modelValue', this.state ? '' : this.value);
        },
    },

    mounted() {
        if (this.checked && !this.state) {
            this.toggle();
        }
    },
};
</script>
